<ngx-loading [show]="isLoading"></ngx-loading>
<header
  class="flex flex-row items-center justify-between -mt-6 mb-0 -mx-6 px-6 h-20 min-h-20 text-white bg-accent-700"
  mat-dialog-title
>
  <div class="flex flex-row items-center">
    <button [mat-dialog-close]="true" class="close-button" mat-icon-button>
      <mat-icon
        [svgIcon]="'heroicons_solid:chevron-left' | transloco"
        class="close-icon"
      ></mat-icon>
    </button>
    <mat-icon class="icon-size-7 text-current" svgIcon="speaker_notes"></mat-icon>
    <div *ngIf="data?.type === 'ADD'" class="ms-3 text-2xl font-semibold tracking-tight capitalize">
      {{ 'add observation' | transloco }}
    </div>

    <div *ngIf="data?.type === 'VIEW'" class="ms-3 text-2xl font-semibold tracking-tight flx-row">
      <div class="pe-2">
        {{
          observationDetails?.type_label === 'SAR'
            ? ('observationType.SAR' | transloco)
            : observationDetails?.type_label
        }}:
      </div>
      <div
        [matTooltip]="observationDetails?.title"
        class="w-full truncate"
        style="max-width: 400px"
      >
        {{ observationDetails?.title | titlecase }}
      </div>
    </div>
  </div>
  <div *ngIf="data?.type === 'VIEW'" class="flex flex-row gap-2 items-center" mat-dialog-content>
    <button
      (click)="publishObservation()"
      [disabled]="checkDisabled()"
      *ngIf="observationDetails?.is_draft"
      class="px-3 mat-dense min-w-0"
      color="primary"
      mat-flat-button
    >
      {{ 'Publish' | transloco }}
    </button>
    <button
      (click)="createACCIssue()"
      *ngIf="!observationDetails?.is_draft"
      [disabled]="
        !observationDetails?.permissions.includes(AccessLevel.AUTODESK_OBSERVATION) ||
        Boolean(observationDetails?.autodesk_issue_id)
      "
      [matTooltip]="
        Boolean(observationDetails?.autodesk_issue_id)
          ? ('Already been added' | transloco)
          : ('Export to Autodesk Construction Cloud (ACC)' | transloco)
      "
      class="my-4 mat-dense"
      color="primary"
      mat-flat-button
      matTooltipPosition="left"
    >
      <mat-icon [svgIcon]="'heroicons_solid:acc'" class="icon-size-4" color="primary"></mat-icon>
      <span class="font-black text-black ms-0.5">{{ 'AUTODESK' | transloco }}</span>
    </button>
    <a
      [matTooltip]="'Open Observation Details' | transloco"
      [routerLink]="'/observations/details/' + observationDetails?.id"
      [target]="'_blank'"
      class="my-4"
      color="primary"
      mat-mini-fab
      matTooltipPosition="left"
    >
      <mat-icon [svgIcon]="'speaker_notes'"></mat-icon>
    </a>
  </div>
</header>

<!-- ADD -->
<ng-container *ngIf="data?.type === 'ADD' && observationForm">
  <div
    [class.is-loading]="isLoading || (isLoadingCustomFields$ | async)"
    class="dark"
    mat-dialog-content
  >
    <div
      *ngIf="data.is_observation_creation_enabled === false"
      class="bg-yellow-500 bg-opacity-20 border border-yellow-500 rounded-md p-3 my-4 flex items-center gap-2"
    >
      <mat-icon svgIcon="mat_outline:warning_amber" class="text-yellow-500"></mat-icon>
      <span class="text-sm">{{
        'Observation creation is currently disabled for this floor. Contact Project Admin to enable.'
          | transloco
      }}</span>
    </div>
    <form [formGroup]="observationForm" class="example-form">
      <div class="flex flex-col">
        <div class="flex sm:flex-row flex-col mt-3">
          <div class="sm:w-1/2 w-full p-3 mt-3 flex justify-center">
            <div class="text-center" id="screenshot">
              <div class="mx-auto relative" style="max-width: 300px">
                <span
                  [ngClass]="
                    translateService.getActiveLang() === 'ar' ? '-left-4 -top-1' : '-right-4 -top-1'
                  "
                  class="text-warn-500 font-bold text-2xl absolute z-10"
                  >*</span
                >

                <div
                  *ngIf="screenShotImage"
                  class="border border-accent-500 rounded-md bg-accent-800 p-1"
                  style="position: relative"
                >
                  <img
                    (click)="fileAttached.click()"
                    [src]="screenShotImage"
                    alt=""
                    class="rounded-md"
                  />

                  <button
                    (click)="removeImg()"
                    class="absolute top-2 right-2"
                    mat-icon-button
                    type="button"
                  >
                    <mat-icon svgIcon="heroicons_outline:trash"></mat-icon>
                  </button>
                </div>
                <button
                  (click)="fileAttached.click()"
                  *ngIf="!screenShotImage"
                  class="border border-accent-500 rounded-md bg-accent-800 border-dashed w-full p-1 relative"
                  type="button"
                >
                  <img alt="" class="rounded-md" [src]="screenshotPlaceholderPath" />
                  <div class="flx-col justify-center items-center absolute-x-center bottom-3">
                    <div class="light bg-transparent text-secondary font-bold">
                      {{ 'No Image Yet' | transloco }}<br />
                      <small>{{ 'Click to upload' | transloco }}</small>
                    </div>
                  </div>
                </button>

                <input
                  #fileAttached
                  (change)="fileChangeEvent($event)"
                  [formControlName]="'screen_shot'"
                  accept="image/*"
                  class="hidden"
                  type="file"
                />
                <mat-error *ngIf="observationForm?.get('screen_shot').invalid">{{
                  'Image is required' | transloco
                }}</mat-error>
              </div>
            </div>
          </div>

          <div class="sm:w-1/2 w-full sm:p-3 p-0">
            <mat-form-field class="w-full">
              <mat-label class="text-primary">{{ 'title' | transloco }} </mat-label>
              <input
                [placeholder]="'Write the tittle ...' | transloco"
                formControlName="title"
                matInput
                [maxlength]="titleMaxLength"
              />
              <mat-error *ngIf="observationForm?.get('title').invalid">{{
                'Title is required' | transloco
              }}</mat-error>
            </mat-form-field>

            <div class="w-full mb-4">
              <label class="text-base font-medium mb-2 block">
                {{ 'description' | transloco }}
                <span
                  *ngIf="nwc_client"
                  [ngClass]="{
                    'text-warn-500':
                      observationForm?.get('description')?.invalid &&
                      observationForm?.get('description')?.dirty,
                    'text-white':
                      !observationForm?.get('description')?.invalid ||
                      !observationForm?.get('description')?.dirty
                  }"
                  class="font-bold text-lg ml-1"
                  >*</span
                >
              </label>
              <quill-editor
                #descriptionEditor
                [formControlName]="'description'"
                [placeholder]="'Write the description' | transloco"
                [styles]="{ direction: isArabic() ? 'rtl' : 'ltr' }"
                (onEditorCreated)="onEditorCreated($event, 'description')"
                [modules]="quillConfig"
                class="w-full"
              ></quill-editor>
              <div
                class="text-sm text-gray-500 mt-1 text-end"
                *ngIf="maxQuillDescriptionLength !== null"
              >
                {{ getDescriptionCharCount() }}/{{ maxQuillDescriptionLength }}
                {{ 'characters' | transloco }}
              </div>
              <mat-error
                *ngIf="
                  observationForm?.get('description')?.invalid &&
                  observationForm?.get('description')?.touched
                "
              >
                {{ 'Description is required' | transloco }}
              </mat-error>
            </div>

            <div class="w-full mb-4">
              <label class="text-base font-medium mb-2 block">
                {{ 'Recommended Corrective Action' | transloco }}
              </label>
              <quill-editor
                #recommendedActionEditor
                [formControlName]="'recommended_corrective_action'"
                [placeholder]="'Write the recommended corrective action' | transloco"
                [styles]="{ direction: isArabic() ? 'rtl' : 'ltr' }"
                (onEditorCreated)="onEditorCreated($event, 'recommendedAction')"
                [modules]="quillConfig"
                class="w-full"
              ></quill-editor>
              <div
                class="text-sm text-gray-500 mt-1 text-end"
                *ngIf="maxQuillRecommendedActionLength !== null"
              >
                {{ getRecommendedActionCharCount() }}/{{ maxQuillRecommendedActionLength }}
                {{ 'characters' | transloco }}
              </div>
            </div>
          </div>
        </div>

        <div class="flex sm:flex-row flex-col justify-between items-stretch mb-3">
          <div class="w-full">
            <mat-form-field appearance="fill" class="w-full">
              <mat-label class="text-primary">{{ 'select-category' | transloco }} </mat-label>
              <mat-select
                formControlName="categories"
                (selectionChange)="onCategorySelectionChange()"
                [multiple]="!nwc_client"
                [compareWith]="compareWithId"
                [disabled]="!!observationForm?.get('type') && !observationForm?.get('type')?.value"
              >
                <mat-option *ngFor="let category of observationCategories" [value]="category.id">
                  {{ category?.category_name_en }}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="observationForm?.get('categories').invalid">{{
                'Category is required' | transloco
              }}</mat-error>
            </mat-form-field>
          </div>

          <!-- Sub-categories selection -->
          <div class="w-full sm:px-3 px-0" *ngIf="shouldShowSubcategoryField()">
            <mat-form-field appearance="fill" class="w-full">
              <mat-label class="text-primary">
                {{ 'select-sub-category' | transloco }}
                <span class="text-warn-500 font-bold text-lg ml-1">*</span>
              </mat-label>
              <mat-select formControlName="child_categories" [multiple]="!nwc_client">
                <mat-option *ngFor="let item of observationChildCategories" [value]="item.id">
                  {{ item?.category_name_en }}
                </mat-option>
              </mat-select>
              <mat-error
                *ngIf="
                  observationForm?.get('child_categories')?.hasError('subcategoryRequired') &&
                  observationForm?.get('child_categories')?.touched
                "
              >
                {{ 'Sub-category is required' | transloco }}
              </mat-error>
            </mat-form-field>
          </div>

          <div class="w-full sm:px-3 px-0">
            <mat-form-field appearance="fill" class="w-full">
              <mat-label class="text-primary">{{ 'select-users' | transloco }}</mat-label>
              <mat-select formControlName="users" multiple>
                <!-- Search input for selecting users -->
                <mat-option>
                  <ngx-mat-select-search
                    #singleSelect
                    [formControl]="searchControl"
                    [noEntriesFoundLabel]="'No result found' | transloco"
                    [placeholderLabel]="'Search' | transloco"
                  ></ngx-mat-select-search>
                </mat-option>
                <mat-option *ngFor="let member of filteredUsers" [value]="member.uuid">
                  {{ member?.name }}
                  <span class="text-secondary">({{ member.email }})</span>
                </mat-option>
              </mat-select>
              <mat-error *ngIf="observationForm?.get('users').invalid">{{
                'Member is required' | transloco
              }}</mat-error>
            </mat-form-field>
          </div>
          <div *ngIf="isFieldVisible('type')" class="w-full">
            <mat-form-field appearance="fill" class="w-full sm:mx-2 mx-0">
              <mat-label class="text-primary">{{ 'type' | transloco }} </mat-label>
              <mat-select formControlName="type" (selectionChange)="getType($event.value)">
                <mat-option *ngFor="let type of observationTypes" [value]="type.value">
                  {{ type.label }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div *ngIf="selectedType && isFieldVisible('due_date')" class="w-full sm:px-3 px-0">
            <mat-form-field *ngIf="!checkMobile()" appearance="fill" class="w-full">
              <mat-label class="text-primary">{{ 'Due Date' | transloco }}</mat-label>

              <input
                (dateChange)="getDate($event.value)"
                [formControl]="currentDueDate"
                [min]="minDate | date: 'yyyy-MM-dd'"
                [ngxMatDatetimePicker]="picker"
                [placeholder]="'Choose a date' | transloco"
                matInput
                readonly
              />
              <mat-datepicker-toggle [for]="picker" matSuffix> </mat-datepicker-toggle>
              <ngx-mat-datetime-picker #picker (opened)="resetPicker()"> </ngx-mat-datetime-picker>
            </mat-form-field>
            <mat-form-field *ngIf="checkMobile()" appearance="fill" class="w-full">
              <mat-label class="text-primary">{{ 'Due Date' | transloco }}</mat-label>

              <input
                #dateInput
                (change)="getDate($event.target.value)"
                [formControl]="currentDueDate"
                [min]="minDate | date: 'yyyy-MM-ddThh:mm'"
                [placeholder]="'Choose a date' | transloco"
                matInput
                type="datetime-local"
              />
              <mat-datepicker-toggle (click)="dateInput.click()" matSuffix> </mat-datepicker-toggle>
            </mat-form-field>
          </div>
        </div>

        <div class="flex sm:flex-row flex-col gap-2 justify-between items-stretch mb-3">
          <div *ngIf="isFieldVisible('significance')" class="w-full">
            <mat-form-field appearance="fill" class="w-full">
              <mat-label class="text-primary">{{ 'significance' | transloco }} </mat-label>
              <mat-select formControlName="significance">
                <mat-option
                  *ngFor="let significance of observationSignificances; index as i"
                  [value]="significance.value"
                >
                  {{
                    i === 0
                      ? ('Select significance' | transloco)
                      : (significance.label | removeUnderscore | titlecase | transloco)
                  }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div *ngIf="isFieldVisible('code')" class="w-full">
            <mat-form-field appearance="fill" class="w-full">
              <mat-label class="text-primary">{{ 'Code' | transloco }}</mat-label>
              <mat-select formControlName="code">
                <mat-option *ngFor="let code of observationCodes; index as i" [value]="code.value">
                  {{ code.label }}
                  <span *ngIf="i !== 0" class="ms-2 text-secondary">({{ code.description }})</span>
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div *ngIf="isFieldVisible('privacy')" class="w-full">
            <section class="example-section">
              <label>{{ 'privacy' | transloco }} </label><br />
              <div class="text-center">
                <mat-radio-group [color]="'primary'" formControlName="privacy">
                  <mat-radio-button value="public">
                    {{ 'public' | transloco }}
                  </mat-radio-button>
                  <span class="mx-2"></span>
                  <mat-radio-button class="mx-2" value="private">
                    {{ 'private' | transloco }}
                  </mat-radio-button>
                </mat-radio-group>
              </div>
            </section>
          </div>
        </div>

        <div class="w-full mb-3">
          <app-observation-hashtags
            [projectId]="_project.id"
            [selectedHashtagsArray]="observationHashtags"
            [isOptional]="true"
            (hashtagsEmitter)="onObservationHashtagsChange($event)"
          ></app-observation-hashtags>
        </div>

        <!-- Custom Fields Section -->
        <app-custom-fields-section
          [customFields$]="customFields$"
          [isLoadingCustomFields$]="isLoadingCustomFields$"
          [form]="observationForm"
          [disabled]="isLoading"
        >
        </app-custom-fields-section>

        <div class="w-full my-3">
          <app-file-uploader
            (filesList)="onAttachmentsChanged($event)"
            [multiple]="true"
            [options]="fileOptions"
          >
          </app-file-uploader>
          <p *ngIf="attachmentsError" class="text-red-500 text-sm mt-1">
            {{ attachmentsError | transloco }}
          </p>
        </div>
      </div>
    </form>
    <!--    <div *ngIf="isLoading" class="is-loading-spinner">-->
    <!--      <mat-spinner diameter="60"></mat-spinner>-->
    <!--    </div>-->
  </div>
  <mat-dialog-actions align="end" class="actions text-center">
    <button type="button" mat-button mat-dialog-close>{{ 'cancel' | transloco }}</button>
    <button
      type="button"
      (click)="onSubmit(true)"
      [disabled]="
        !observationForm?.value.title?.trim() ||
        !observationForm?.value.type ||
        !fileToUpload ||
        isLoading ||
        (isLoadingCustomFields$ | async)
      "
      mat-raised-button
    >
      {{ 'Save Draft' | transloco }}
    </button>
    <button
      type="button"
      (click)="onSubmit(false)"
      [disabled]="
        isLoading ||
        (isLoadingCustomFields$ | async) ||
        observationForm?.invalid ||
        !observationForm?.value.title?.trim() ||
        isMissingRequiredAttachments
      "
      color="primary"
      mat-raised-button
      type="submit"
    >
      {{ 'Publish' | transloco }}
    </button>
  </mat-dialog-actions>
</ng-container>

<!-- View -->
<ng-container *ngIf="data?.type === 'VIEW'">
  <div mat-dialog-content>
    <app-shared-observation-details
      (onEditObservationAttachments)="editObservationAttachments($event)"
      (onEditObservationCategories)="editObservationCategories($event)"
      (onEditObservationDescription)="editObservationDescription($event)"
      (onEditObservationEvidence)="editObservationEvidence($event)"
      (onEditObservationDueDate)="editObservationDueDate($event)"
      (onEditObservationPrivacy)="editObservationPrivacy($event)"
      (onEditObservationStatus)="editObservationStatus($event)"
      (onEditObservationTitle)="editObservationTitle($event)"
      (onEditObservationRecommendedAction)="editObservationRecommendedAction($event)"
      (onEditObservationType)="editObservationType($event)"
      (onEditObservationSignificance)="editObservationSignificance($event)"
      (onEditObservationCode)="editObservationCode($event)"
      (onEditCustomFields)="editObservationCustomFields($event)"
      [preview]="false"
      [observationDetails]="observationDetails"
      [projectId]="_project.id"
      [customFields]="viewCustomFields$.value"
      [isLoadingCustomFields]="viewIsLoadingCustomFields$.value"
    ></app-shared-observation-details>
  </div>
</ng-container>
